import React, { useContext, useEffect, useRef, useState } from 'react';
import './TodaysPrint.css';
import { useParams } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { formatedDate } from '../../Helper/constent';

const TodaysPrint = () => {
    const { store_id, from_date, to_date, encrypted_code } = useParams();

    const toast = useRef(null);

    const [dataLoading, setDataLoading] = useState(true);
    const [invoiceData, setInvoiceData] = useState({});
    const [expenses, setExpenses] = useState([]);
    const [products, setProducts] = useState([]);
    const [orders, setOrders] = useState([]);
    const [user, setUser] = useState({});
    const [calculation, setCalculation] = useState({});
    const [hasData, setHasData] = useState(true);

    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const headers = apiHeadersJson;

    const handlePrint = () => {
        window.print();
    };

    const GetList = async () => {
        setDataLoading(true);
        try {
            let url = `${apiUrl}/Reports/GetTodaysSaleInvoice`;

            if (encrypted_code) {
                url = `${apiUrl}/Reports/GetTodaysSaleInvoiceFromBackUp`;
            }

            const response = await axios.get(url, {
                params: { store_id, from_date, to_date, encrypted_code },
                headers
            });

            const { success, expenses, orders, data, products, user, message, calculations } = response.data;

            if (success) {
                setInvoiceData(data);
                setProducts(products || []);
                setOrders(orders || []);
                setUser(user || {});
                setExpenses(expenses)
                setHasData(true);
                setCalculation(calculations)
            } else {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
                setHasData(false);
            }
        } catch (error) {
            console.error('Error fetching invoice:', error);
            setHasData(false);
        } finally {
            setDataLoading(false);
        }
    };

    useEffect(() => {
        GetList();
    }, []);

    useEffect(() => {
        // Ensure store and store_logo_url exist
        if (invoiceData && invoiceData?.store_logo_url) {
            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'icon';
            link.href = invoiceData?.store_logo_url;
            document.getElementsByTagName('head')[0].appendChild(link);
            document.title = invoiceData?.store_name;
        }
    }, [invoiceData]);

    if (dataLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
            </div>
        );
    }

    if (!hasData || !invoiceData || !user) {
        return (
            <div className="text-center mt-4">
                <h5>No invoice data available.</h5>
            </div>
        );
    }

    const purchaseDetails = invoiceData;

    const groupedProducts = products.reduce((acc, product) => {
        if (!acc[product.category_name]) {
            acc[product.category_name] = [];
        }
        acc[product.category_name].push(product);
        return acc;
    }, {});

    const groupedOrders = orders.reduce((acc, product) => {
        if (!acc[product.category_name]) {
            acc[product.category_name] = [];
        }
        acc[product.category_name].push(product);
        return acc;
    }, {});

    return (
        <>
            <div className="todays-invoice-container">
                <div className="d-flex justify-content-center align-items-center">
                    <img src={purchaseDetails.store_logo_url} alt="Logo" width={120} />
                </div>
                <p className='text-center mb-2 mt-0'>{purchaseDetails.store_address}</p>
                <div className="todays-invoice-header">
                    <p><span>FROM DATE:</span> {formatedDate(from_date)}</p>
                    <p><span>TO Date:</span> {formatedDate(to_date)}</p>
                </div>
                <div className="todays-invoice-details">
                    <p><span>Print by:</span> {user.user_name}</p>
                    <p><span>Date & Time:</span> {new Date().toLocaleString()}</p>
                </div>

                {/* SALES Section */}
                <div className="section-title">{products.length === 0 ? "NO SALES" : "SALES"}</div>
                {products.length > 0 && <div className="todays-product-list">
                    <table>
                        <thead>
                            <tr>
                                <th className='text-start'>Items</th>
                                <th className='text-end'>Qty</th>
                                <th className='text-end'>Price</th>
                                <th className='text-end'>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedProducts).map(([category, items]) => (
                                <React.Fragment key={category}>
                                    <tr className="todays-category-row">
                                        <td colSpan="4" className="todays-category-header">
                                            <span>{category}</span>
                                        </td>
                                    </tr>
                                    {items.map((product, index) => (
                                        <tr key={index}>
                                            <td className='text-start'>{product.product_name}</td>
                                            <td className='text-end'>{product.total_qty} {product.total_free_qty > 0 && <>+ {product.total_free_qty}</>}</td>
                                            <td className='text-end'>{product.product_sale_rate}</td>
                                            <td className='text-end'>{product.total_amount}</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>}

                {/* Divider between Sales and Orders */}
                <div className="section-divider"></div>

                {/* ORDERS Section */}
                <div className="section-title">{orders.length === 0 ? "NO ORDERS" : 'ORDERS'}</div>
                {orders.length > 0 &&
                    <div className="todays-product-list">
                        <table>
                            <thead>
                                <tr>
                                    <th className='text-start'>Items</th>
                                    <th className='text-end'>Qty</th>
                                    <th className='text-end'>Price</th>
                                    <th className='text-end'>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(groupedOrders).map(([category, items]) => (
                                    <React.Fragment key={category}>
                                        <tr className="todays-category-row">
                                            <td colSpan="4" className="todays-category-header">
                                                <span>{category}</span>
                                            </td>
                                        </tr>
                                        {items.map((product, index) => (
                                            <tr key={index}>
                                                <td className='text-start'>{product.product_name}</td>
                                                <td className='text-end'>{product.total_qty} {product.total_free_qty > 0 && <>+ {product.total_free_qty}</>}</td>
                                                <td className='text-end'>{product.product_sale_rate}</td>
                                                <td className='text-end'>{product.total_amount}</td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>}

                {/* Divider between Orders and Expenses */}
                <div className="section-divider"></div>

                {/* EXPENSES Section */}
                {expenses && expenses.length > 0 && (
                    <>
                        <div className="section-title">EXPENSES</div>
                        <div className="todays-product-list">
                            <table>
                                <thead>
                                    <tr style={{ borderBottom: '1px solid #000' }}>
                                        <th className='text-start'>Name</th>
                                        <th className='text-end'>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {expenses.map((expense, index) => (
                                        <tr key={index}>
                                            <td className='text-start'>{expense.expense_name}</td>
                                            <td className='text-end'>{expense.expense_amount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                <div className="financial-summary">
                    <h3 className="summary-title">FINANCIAL SUMMARY</h3>

                    {calculation.total_sale_amount > 0 && <div className="summary-row">
                        <span>Total Sales:</span>
                        <span>Rs {calculation.total_sale_amount || '0.00'}</span>
                    </div>}

                    {calculation.total_advance_amount > 0 && <div className="summary-row">
                        <span>Total Advances:</span>
                        <span>Rs {calculation.total_advance_amount || '0.00'}</span>
                    </div>}

                    {calculation.total_order_amount > 0 && <div className="summary-row">
                        <span>Total Orders:</span>
                        <span>Rs {calculation.total_order_amount || '0.00'}</span>
                    </div>}

                    {calculation.total_discount_amount > 0 && <div className="summary-row">
                        <span>Total commission:</span>
                        <span>Rs {calculation.total_discount_amount || '0.00'}</span>
                    </div>}

                    {calculation.total_expenses_amount > 0 && <div className="summary-row">
                        <span>Total Expenses:</span>
                        <span>Rs {calculation.total_expenses_amount || '0.00'}</span>
                    </div>}

                    {calculation?.total_sale_return_amount && calculation?.total_sale_return_amount > 0 && <div className="summary-row">
                        <span>Total Returns:</span>
                        <span>Rs {calculation.total_sale_return_amount || '0.00'}</span>
                    </div>}

                    <div className="summary-total">
                        <span>NET TOTAL:</span>
                        <span>Rs {calculation.net_total || '0.00'}</span>
                    </div>
                </div>
            </div>
            <button onClick={handlePrint} className="todays-print-button">Print</button>
        </>
    );
};

export default TodaysPrint;
